<template>
  <div class="inline-block relative">
    
    <ul class="-mt-1">
      <li v-for="(match, i) in matches" 
        class="match"
        :class="{'active': activematch === match.value}"
        @click="selectItem(i)"
      >
        <a 
          :href="'?type=' + match.value"
          >
            {{ match.name }}
        </a>
      </li>
    </ul>
    <div class="absolute -mt-3">
        <button type="submit" class="commitbutton bg-yellow-400 text-black leading-normal text-xs transition font-bold rounded-t-none rounded-b">
          This Match is Most Me
        </button>
    </div>
    
  </div>
</template>

<script>
    import axios from 'axios'

    export default {

        props: {
            options: '',
            placeholder: {
                default: 'Add Admin to Organization'
            },
            axios:'',
            url: '',
            activematch: '',
        },

        data() {
          return {
            success: false,
            loaded: true,
            matches: this.options,
            selected: '',
            activeItem: null,
          }
        },

        methods: {
          selectItem(i) {
            this.activeItem = i;
            this.selected = true;
          },
          saveMatch: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.put(
                  this.axios.replace("selected.id", this.selected.id),
                {
                    admin: 1
                 }
              ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },

    }
</script>
